import { useCallback, useEffect, useState } from 'react'
import { TADMemberships } from '../type'

export const useFoldersGroup = (folders: string[], searchText?: string) => {
  const [isLoading, setIsLoading] = useState(false)
  const [groupsInFolder, setGroupsInFolder] = useState<TADMemberships>({ results: [], total_count: 0 })
  const [filteredGroupsInFolder, setFilteredGroupsInFolder] = useState<TADMemberships>({ results: [], total_count: 0 })

  const filterGroupInFolder = useCallback(() => {
    setIsLoading(true)
    try {
      const filteredResults = groupsInFolder.results.filter((group) => {
        const isInFolder = group.FolderName !== undefined && folders.includes(group.FolderName)
        if (!searchText) {
          return isInFolder
        }
        return (
          isInFolder &&
          (group.GroupName?.toLowerCase().includes(searchText.toLowerCase()) ||
            group.Description?.toLowerCase().includes(searchText.toLowerCase()))
        )
      })
      setFilteredGroupsInFolder({
        results: filteredResults,
        total_count: filteredResults.length,
        total_pages: Math.ceil(filteredResults.length / 8),
        page_number: 1,
        max_page_size: groupsInFolder.max_page_size,
      })
    } finally {
      setIsLoading(false)
    }
  }, [folders, groupsInFolder, searchText])

  useEffect(() => {
    if (folders.length > 0) {
      filterGroupInFolder()
    } else {
      setFilteredGroupsInFolder({ results: [], total_count: 0 })
    }
  }, [folders, groupsInFolder, filterGroupInFolder])

  return {
    groupsInFolder,
    filteredGroupsInFolder,
    isGroupsInFolderLoading: isLoading,
    setGroupsInFolder,
  }
}
